import { createStore } from '@hs/shared';

/**
 * Redux Store
 * 
 * ✅ 使用 shared 包的工厂函数创建 store
 */
export const store = createStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

